import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DashboardTableTheme } from './dashboard-datatable.service';

export interface DashboardTableThemeOption {
  value: DashboardTableTheme;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardTableThemeService {
  private static readonly STORAGE_KEY = 'noc.dashboard.tableTheme';

  private activeTheme: DashboardTableTheme = 'paper';
  readonly changed$ = new Subject<DashboardTableTheme>();

  readonly options: DashboardTableThemeOption[] = [
    { value: 'paper', label: 'Paper (padrão)' },
    { value: 'accent', label: 'Cabeçalho colorido' },
    { value: 'minimal', label: 'Minimalista' },
    { value: 'striped-bold', label: 'Listras destacadas' }
  ];

  constructor() {
    this.activeTheme = this.loadStored() || 'paper';
  }

  getActiveTheme(): DashboardTableTheme {
    return this.activeTheme;
  }

  setActiveTheme(theme: DashboardTableTheme): void {
    if (!this.options.some(x => x.value === theme)) {
      return;
    }
    this.activeTheme = theme;
    this.persist(theme);
    this.changed$.next(theme);
  }

  private loadStored(): DashboardTableTheme | null {
    try {
      const raw = sessionStorage.getItem(DashboardTableThemeService.STORAGE_KEY);
      if (raw && this.options.some(x => x.value === raw)) {
        return raw as DashboardTableTheme;
      }
    } catch {
      // ignore
    }
    return null;
  }

  private persist(theme: DashboardTableTheme): void {
    try {
      sessionStorage.setItem(DashboardTableThemeService.STORAGE_KEY, theme);
    } catch {
      // ignore
    }
  }
}
